const $$splitComponentImporter = () => import('/home/runner/work/inspecttec-frontend-admin/inspecttec-frontend-admin/src/routes/client/layout-modes.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { Permissions } from "@/constants/permissions";
import { requirePermission } from "@/lib/auth/permission-guard";
import type { CatalogEntry } from "@/types/api/layout-mode";
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/client/layout-modes")({
  beforeLoad: args => requirePermission(Permissions.LayoutModes.Manage, args),
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});

/**
 * SystemAdmin: per-client LayoutMode enablement.
 *
 * Renders every <c>SystemLayoutMode</c> in the catalog as a row with
 * an entitlement toggle. Flipping the toggle calls the backend grant
 * (PR B5a `POST /clients/{id}/layout-modes`) or revoke
 * (`DELETE /clients/{id}/layout-modes/{key}`) endpoint. Optimistic
 * UI not used here — the round-trip is fast and the API responds with
 * authoritative state we re-read.
 *
 * Standard is auto-granted at signup (and to every existing client via
 * the B1 backfill), so the Standard row's toggle is shown ON but
 * disabled — preventing accidental revocation of the universal
 * default. (The backend would still accept it; this is just a UX
 * guardrail.)
 */